ui-cms-supernumber {
  display: block;
  width: 100%;
  word-wrap: break-word;

  .supernumber {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    &__overline {
      font-weight: $sd-fontWeight-bold;
      margin-bottom: $sd-spacing-2;
    }

    &__number {
      color: $sd-textColor-primary-DEFAULT;
      line-height: $sd-lineHeight-tight;

      &--inverted {
        color: $sd-textColor-white;
      }
    }

    &__subline {
      font-weight: $sd-fontWeight-bold;
      margin-top: $sd-spacing-4;
      margin-bottom: $sd-spacing-4;
    }

    &__description {
      padding-top: $sd-spacing-2;
    }

    &--sm {
      .supernumber__number {
        font-size: $sd-fontSize-3xl;
      }
    }

    &--md {
      .supernumber__number {
        font-size: $sd-fontSize-4xl;
      }
    }

    &--lg {
      .supernumber__number {
        font-size: 72px;
      }
    }
  }
}
